<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
        >

            <template #modal-title>
                Validation failed.
            </template>

            <div v-if="untitled_modals && untitled_modals.length" class="validation-report mb-3">
                <h5 class="validation-report-title mb-3">
                    Panel Issues
                </h5>
                <template v-if="untitled_modals && untitled_modals.length">
                    <div class="font-weight-bold mb-2">
                        Every panel must have a title before publishing can take place.
                    </div>
                    These panels are missing titles:
                    <div>
                        <b-table striped hover :items="untitled_modals" :fields="panel_fields"></b-table>
                        * The panel parent id will be the week id if the panel is week level, article id if article level etc.
                    </div>
                </template>
            </div>

            <template #modal-footer>
                <b-button variant="light" @click="cancel">
                    Close
                </b-button>
            </template>

        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
.validation-report {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    padding: 1rem;
}

.validation-report-title {
    font-size: 1.35rem;
    font-weight: 700;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
    data: () => ({
        panel_fields: ['panel_type', 'panel_parent_id', 'unit_number', 'week_number', 'title'],
    }),
    props: [
        'value',
        'untitled_modals',
    ],
    components: {},
    computed: {
        ...mapState({
            // validating: state => state.utilities.validating
        }),
        modal_id () {
            let modal_id = 'export-translation-json-modal'
            return modal_id
        }
    },
    watch: {},
    methods: {
        cancel (event) {
            event.preventDefault()

            this.hide()
        },
        hide () {
            this.$emit('hide')
        },
        hidden () {

        }
    }
}
</script>
